import type { ILayer } from './layer';
import type { IStage } from './stage';

export declare function createLayer(canvasId?: string): ILayer;
export declare function createStage(w: number, h: number): IStage;
